import { RoutalPalette } from '@nx-smartmonkey/ui';

import tinycolor from 'tinycolor2';
import { getRouteColor, getTaskStatusColor } from '../../constants/Colors';
import { STOP_TASK_STATUS } from '../../constants/Stops';
import { Driver } from '../../domain/driver/Driver';
import { TaskStatus } from '../../domain/task/TaskStatus';

type TaskCircleColorProps = {
  color?: string;
  status?: TaskStatus;
  driver?: Driver;
  isSelected?: boolean;
  planDrivers?: Driver[];
  size?: number;
};

const LIGHTEN_AMOUNT = 35;

const TaskCircleColor = ({ color, status, driver, isSelected, planDrivers, size = 24 }: TaskCircleColorProps) => {
  const routeColor = color || (driver && planDrivers ? getRouteColor(driver, planDrivers) : RoutalPalette.grey2);

  const tBaseColor = status && status !== STOP_TASK_STATUS.pending ? getTaskStatusColor(status) : routeColor;

  const lightenBackgroundColor =
    status && status !== STOP_TASK_STATUS.pending
      ? getTaskStatusColor(status, `light`)
      : tinycolor(tBaseColor).lighten(LIGHTEN_AMOUNT).toString();

  const getFillColor = () => (isSelected ? routeColor : lightenBackgroundColor);

  return (
    <div
      style={{
        position: `relative`,
        width: `${size}px`,
        height: `${size}px`,
        display: `flex`,
        flexDirection: `row`,
        justifyContent: `center`,
        alignItems: `center`,
      }}
    >
      <div
        style={{
          padding: `0px`,
          width: `100%`,
          height: `100%`,
          position: `relative`,
        }}
      >
        <svg viewBox="0 0 48 48" style={{ position: `relative` }}>
          <circle
            cx="24"
            cy="24"
            r="21"
            fill={getFillColor()}
            stroke={tBaseColor}
            strokeWidth={size > 24 ? `2` : `4`}
          />
        </svg>
      </div>
    </div>
  );
};

export default TaskCircleColor;
